// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Data_Show = require("../Data.Show/index.js");
var MD5 = (function () {
    function MD5() {

    };
    MD5.value = new MD5();
    return MD5;
})();
var SHA256 = (function () {
    function SHA256() {

    };
    SHA256.value = new SHA256();
    return SHA256;
})();
var SHA512 = (function () {
    function SHA512() {

    };
    SHA512.value = new SHA512();
    return SHA512;
})();
var showAlgorithm = new Data_Show.Show(function (v) {
    if (v instanceof MD5) {
        return "md5";
    };
    if (v instanceof SHA256) {
        return "sha256";
    };
    if (v instanceof SHA512) {
        return "sha512";
    };
    throw new Error("Failed pattern match at Random.Hash (line 16, column 1 - line 19, column 25): " + [ v.constructor.name ]);
});
var hash = function (a) {
    return $foreign["_hash"](Data_Show.show(showAlgorithm)(a));
};
module.exports = {
    MD5: MD5,
    SHA256: SHA256,
    SHA512: SHA512,
    hash: hash,
    showAlgorithm: showAlgorithm
};
